import { useEffect } from "react";
import "../styles/Contents.css";

export default function AboutUs() {

  // Scroll Reveal Animation
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page about-page">

      {/* ===== HERO SECTION ===== */}
      <section className="about-hero reveal">
        <h1>About <img src="/images/access.png"
              alt="ACCESS"
              className="acces-img" /></h1>
        <p>
          Shaping confident learners, building strong academic foundations,
          and transforming results.
        </p>
      </section>

      {/* ===== INTRO SECTION ===== */}
      <section className="about-section">
        <div className="about-row"> 
          <div className="about-text reveal-left">
          <h2>Who We Are</h2>
          <p>
            <strong>ACCESS Coaching Institute</strong> has own identity in the field of coaching for 10th Board exams and other entrance exams. The reason for success is simple; sincerity and adherence to fundamentals. The students are encouraged to use and analyze concepts in the most simplistic manner. It enables them to solve difficult problems in the minimum possible time.
          </p>
          <p>
            We believe in simplifying concepts, strengthening fundamentals,
            and training students to solve even complex problems with clarity
            and confidence.
          </p>
        </div>
        <img src="/images/study.jpg" alt="ACCESS Classroom" className="about-image " />

        </div>

      
      </section>

      {/* ===== MISSION SECTION ===== */}
      <section className="mission-section reveal">
        <h2>Our Mission</h2>

        <div className="mission-grid">
          <div className="mission-card reveal delay-1">
            <h3>📘 Strong Fundamentals</h3>
            <p>Build crystal-clear concepts that last a lifetime.</p>
          </div>

          <div className="mission-card reveal delay-2">
            <h3>🎯 Result-Oriented</h3>
            <p>Focused preparation aligned with exam patterns.</p>
          </div>

          <div className="mission-card reveal delay-3">
            <h3>🤝 Student First</h3>
            <p>Personal attention and mentorship for every learner.</p>
          </div>
        </div>
      </section>

      {/* ===== WHY ACCESS ===== */}
      <section className="why-access-section">
        <h2 className="reveal">Why Us?</h2>

        <div className="why-access-grid">
          <div className="why-item reveal delay-1">
            ✔ Commitment towards Quality Education.
          </div>
          <div className="why-item reveal delay-2">
            ✔ Complete Syllabus Revision for 10th(CBSE & STATE).
          </div>
          <div className="why-item reveal delay-3">
            ✔ Regular Test & Performance Analysis and MOCK Test.
          </div>
          <div className="why-item reveal delay-1">
            ✔ Unique way of teaching students with respect to their understand level.
          </div>
          <div className="why-item reveal delay-2">
            ✔ Students spend more time with books and pen in our STAY & STUDY concept.
          </div>
          <div className="why-item reveal delay-3">
            ✔ Expert Faculty | Concept Clarity | Exam Confidence.
          </div>
        </div>
      </section>

      {/* ===== CLOSING ===== */}
      <section className="about-footer reveal">
        <p>
          At <strong>ACCESS</strong>, education is not just about exams —
          it’s about building confidence, discipline, and a strong future.
        </p>
      </section>

    </div>
  );
}
